import { WhitelabelBranding } from '../model'

const setAbsolutePath = (path: string) => {
    return path.includes('http') ? path : new URL(path, window.location.origin).href
}

function updateLinkElement(rel: string, href: string, sizes?: string) {
    const selector = `link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ''}`
    let link = document.querySelector(selector) as HTMLLinkElement

    if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', rel)
        if (sizes) link.setAttribute('sizes', sizes)
        document.head.appendChild(link)
    }

    link.href = setAbsolutePath(href)
}

export const setManifestData = (data: WhitelabelBranding) => {
    const manifestData = {
        short_name: data.manifest.short_name || data.organisation,
        name: data.manifest.name || data.organisation,
        description: data.manifest.description || data.description,
        id: data.manifest.id || '',
        icons: data.manifest.icons
            ? data.manifest.icons.map((icon) => {
                  icon.src = setAbsolutePath(icon.src)
                  return icon
              })
            : [
                  {
                      src: setAbsolutePath(data.logo.favicon16x16),
                      sizes: '16x16',
                      type: 'image/png'
                  },
                  {
                      src: setAbsolutePath(data.logo.favicon32x32),
                      sizes: '32x32',
                      type: 'image/png'
                  }
              ],
        start_url: new URL(window.location.origin).href,
        display: data.manifest.display || 'standalone',
        theme_color: data.manifest.theme_color || '#000000',
        background_color: data.manifest.background_color || '#ffffff',
        shortcuts: [
            {
                name: 'Nieuwe opdracht',
                short_name: 'Nieuwe opdracht',
                description: 'Nieuwe opdracht',
                url: setAbsolutePath('/dashboard/new-order')
            },
            {
                name: 'Opdrachten',
                short_name: 'Opdrachten',
                description: 'Opdrachten',
                url: setAbsolutePath('/dashboard/orders')
            },
            {
                name: 'Afspraken',
                short_name: 'Afspraken',
                description: 'Afspraken',
                url: setAbsolutePath('/dashboard/appointments')
            },
            {
                name: 'Opleveringen',
                short_name: 'Opleveringen',
                description: 'Opleveringen',
                url: setAbsolutePath('/dashboard/deliveries')
            }
        ]
    }
    if (data.manifest.theme_color) {
        let themeColor = document.querySelector('meta[name="theme-color"]')
        if (!themeColor) {
            themeColor = document.createElement('meta')
            themeColor.setAttribute('name', 'theme-color')
            document.head.appendChild(themeColor)
        }
        themeColor.setAttribute('content', data.manifest.theme_color)
    }
    // Convert manifest to JSON and create a blob
    const manifestJson = JSON.stringify(manifestData)
    const blob = new Blob([manifestJson], { type: 'application/manifest+json' })

    // Create object URL for the blob
    const manifestUrl = URL.createObjectURL(blob)

    // Find or create the manifest link element
    let link = document.querySelector('link[rel="manifest"]') as HTMLLinkElement
    if (!link) {
        link = document.createElement('link')
        link.rel = 'manifest'
        document.head.appendChild(link)
    }

    // Set the href to the blob URL
    link.href = manifestUrl

    // Clean up the previous URL object to prevent memory leaks
    const previousUrl = link.getAttribute('data-previous-manifest-url')
    if (previousUrl) {
        URL.revokeObjectURL(previousUrl)
    }
    link.setAttribute('data-previous-manifest-url', manifestUrl)
}

export const applyBranding = async (brandData: WhitelabelBranding) => {
    if (brandData.colors) {
        Object.entries(brandData.colors).forEach(([key, value]) => {
            document.documentElement.style.setProperty(`--tb-${key}`, value)
        })
    }
    if (brandData.organisation) {
        document.title = brandData.organisation
    }
    if (brandData.description) {
        document.querySelector('meta[name="description"]')?.setAttribute('content', brandData.description)
    }

    Object.entries(brandData.logo).forEach(([key, value]) => {
        switch (key) {
            case 'favicon':
                updateLinkElement('icon', value)
                break
            case 'appleTouchIcon':
                updateLinkElement('apple-touch-icon', value)
                break
            case 'favicon16x16':
                updateLinkElement('icon', value, '16x16')
                break
            case 'favicon32x32':
                updateLinkElement('icon', value, '32x32')
                break
        }
    })
    if (brandData.manifest) {
        setManifestData(brandData)
    }
}
